<template>
    <div class="container">
        <div class="page-header">
            <h2 class="h2">Adicionar usuário</h2>
            <router-link to="/admin" class="btn btn-secondary">Voltar</router-link>
        </div>

        <div class="card">
            <form @submit.prevent="salvarLocal" class="candidate-form">
                <div class="form-row">
                    <div class="form-group">
                        <label for="nome">Nome</label>
                        <input type="text" id="nome" v-model="formData.nome" required placeholder="Nome" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input type="text" id="email" v-model="formData.email" required placeholder="Email" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="perfil">Perfil</label>
                        <select name="perfil" id="perfil" v-model="formData.perfil">
                            <option value="Admin">Administrador</option>
                            <option value="Scouter">Scouter</option>
                        </select>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="senha">Senha</label>
                        <input type="password" id="senha" v-model="formData.senha" required placeholder="Senha" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="confirmacaoSenha">Confirma senha</label>
                        <input type="password" id="confirmacaoSenha" v-model="confirmarSenha" required
                            placeholder="Confirmar senha" />
                    </div>
                </div>

                <div class="error" v-if="error">{{ error }}</div>
                <div class="success" v-if="success">{{ success }}</div>

                <div class="form-actions">
                    <button type="submit" class="btn btn-primary" v-if="!loading">
                        {{ "Salvar" }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { api } from '../services/api';

const router = useRouter();
const formData = reactive({
    nome: "",
    email: "",
    perfil: "",
    senha: "",
});
const confirmarSenha = ref("");
const loading = ref(false);
const success = ref(false);
const error = ref(false);

async function salvarLocal() {
    if (formData.nome.value == "" || formData.email.value == "" || formData.perfil.value == "" || formData.senha.value == "" || confirmarSenha.value == "") {
        error.value = 'Você precisa preencher todos os campos';
        return
    }

    if (formData.senha != confirmarSenha.value) {
        error.value = "As senhas informadas são diferentes";
        return
    }

    try {
        await api.adicionaScouter(formData);
        loading.value = true;
        success.value = "Usuário adicionado com sucesso!";
        setTimeout(() => {
            router.push("/admin");
        }, 3000)
    } catch (error) {
        loading.value = false;
        error.value = error.message
    }
}

onMounted(() => {
})

</script>

<style scoped>
.success {
    font-size: 18px;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.candidate-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-row {
    max-width: 600px;
    width: 100%;
    margin-bottom: 15px;
}

.form-actions {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
}

@media (max-width: 768px) {
    .page-header {
        flex-direction: column;
        gap: 1rem;
    }

    .form-row {
        grid-template-columns: 1fr;
        gap: 0;
    }

    .form-actions {
        flex-direction: column;
    }
}
</style>
